import {full_url} from 'helpers/url'
import offlineProgressSync from '../helpers/OfflineProgressSync';
import { updateProgress } from '../helpers/progressHelper';

export const EXPANDED_MOD_MAP_LOG = "ExpandedModMapLog"
export const OPENED_DOCUMENT_LOG = "OpenedDocumentLog"
export const OPENED_LAB_VALUES_LOG = "OpenedLabValuesLog"
export const OPENED_MOD_MAP_LOG = "OpenedModMapLog"
export const OPENED_SECTION_LOG = "OpenedSectionLog"

export function postDocumentUserLog(document_id, log_type, args={}) {
  // Check if we should queue for offline sync
  if (offlineProgressSync.shouldQueue()) {
    console.log('Offline: Queuing document user log for later sync');
    offlineProgressSync.queueDocumentUserLog(document_id, log_type, args);
    return;
  }

  fetch(full_url(`/documents/${document_id}/document_user_logs`), {
    method: 'POST',
    headers: ReactOnRails.authenticityHeaders({
      'Accept': "application/json",
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({
      document_user_log: {
        type: log_type,
        created_at: Math.floor(Date.now() / 1000),
        ...args
      }
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    updateProgress(data);
  })
  .catch(error => {
    console.error(error);
    
    // If network error and we have offline sync, queue it
    if (offlineProgressSync.shouldQueue() && error.message.includes('fetch')) {
      console.log('Network error: Queuing document user log for offline sync');
      offlineProgressSync.queueDocumentUserLog(document_id, log_type, args);
    }
    
    // Uncomment the next line if you want to see logging failures in Rollbar. This is noisy and consuming a lot of Rollbar quota. -NJ 9/24/2025
    // Rollbar.warning("Logging Data Failed");
  });
}
